module.exports = __webpack_public_path__ + "media/images/icon__profile-2024e821606f4e8fac959d33d2f87368.png";